import React from 'react';
import { SparkIcon } from '@spark';
import { colors } from '@/shared/tokens/colors';

const ScrollArrow = ({ direction, onClick, compact = false }) => {
    const iconSlug = direction === 'left' ? 'chevron-left' : 'chevron-right';
    const position = direction === 'left' ? { left: 0 } : { right: 0 };
    const size = compact ? 20 : 40;
    const hoverTransform = compact ? 'scale(1.08)' : 'translateY(-50%) scale(1.1)';

    return (
        <div
            onClick={onClick}
            className={compact ? 'scroll-arrow scroll-arrow--compact' : 'scroll-arrow'}
            style={{
                ...(compact
                    ? { position: 'relative', flexShrink: 0 }
                    : {
                          position: 'absolute',
                          ...position,
                          top: '50%',
                          transform: 'translateY(-50%)',
                          zIndex: 2,
                      }),
                border: `1px solid ${colors.buttonsBlue}`,
                borderRadius: '50%',
                width: `${size}px`,
                height: `${size}px`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                boxShadow: compact ? '0 1px 4px rgba(0, 0, 0, 0.12)' : '0 2px 8px rgba(0, 0, 0, 0.15)',
                transition: 'all 0.3s ease',
            }}
        >
            <SparkIcon
                slug={iconSlug}
                size={compact ? 'small' : 'medium'}
                className="scroll-arrow-icon"
            />
            <style jsx="true">{`
                .scroll-arrow:hover {
                    background: ${colors.buttonsBlue};
                    transform: ${hoverTransform};
                }
                .scroll-arrow:hover .scroll-arrow-icon {
                    color: white !important;
                }
            `}</style>
        </div>
    );
};

export default ScrollArrow; 